import { getColumnFilters } from '../components/Datatable';

export function getItemFromLocalStorage(key: string): any | null {
  const item = localStorage.getItem(key);
  if (!item) {
    return null;
  }
  return JSON.parse(item);
}

export function setItemInLocalStorage(key: string, value: string) {
  localStorage.setItem(key, JSON.stringify(value));
}

export type ConfigKey = 'dashboardConfig' | 'organisationConfig' | 'emailsLogConfig';

export function getDatatableColumnConfig(configKey: ConfigKey, columnName: string) {
  let config = getItemFromLocalStorage(configKey);
  if (config != null) {
    return config['columns'].find((column: any) => column.name == columnName);
  }
  return null;
}

export function getDatatableConfig(configKey: ConfigKey, settingKey: string) {
  let config = getItemFromLocalStorage(configKey);
  if (config != null) {
    return config[settingKey];
  }
  return null;
}

/** A column's filter values from the table state mui-datatables saves (filterList is indexed like columns). */
export function getStoredColumnFilter(configKey: ConfigKey, columnName: string): string[] {
  return getStoredColumnFilters(configKey)[columnName] || [];
}

/** Every column's filter values by column name, from the table state mui-datatables saves. Columns with no filter are left out. */
export function getStoredColumnFilters(configKey: ConfigKey): Record<string, string[]> {
  const columns: { name: string }[] = getDatatableConfig(configKey, 'columns') || [];
  const filterList: string[][] = getDatatableConfig(configKey, 'filterList') || [];
  return getColumnFilters(columns, filterList);
}
